// This is the one allowed use of fetch that allows us to not use it elsewhere
/* eslint-disable no-restricted-globals */

import {parseCsrfTokenFromPage} from './parseCsrfTokenFromPage';

export const supportFetch: typeof fetch = (input, init?) => {
  const csrfToken = parseCsrfTokenFromPage();

  const augmentedHeaders: Record<string, unknown> = {
    ...((init && init.headers) || {}),
    'X-Requested-With': 'fetch',
  };

  if (csrfToken) {
    augmentedHeaders['x-stripe-csrf-token'] = csrfToken;
  }

  const augmentedInit = {
    credentials: 'same-origin',
    ...(init || {}),
    headers: augmentedHeaders as HeadersInit,
  } as const;

  return fetch(input, augmentedInit);
};
